<template>
  <div class="app-tariff-modal-wrapper">
    <TariffChangeBookingModal
      :show.sync = show
      :content = modalContent
      :actions = "createActions()"
      @click:booking="booking()"
    >
      <template v-for="slot in possibleChildSlotsFor('Modal', tariff.tariffId)" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </TariffChangeBookingModal>
  </div>
</template>
<script>
import TariffChangeBookingModal from '@/components/process/generic/Tariff/generic/TariffChangeBookingModal.vue'
import durationUnit from '@/mixins/durationUnit'
import slotProxy from '@/mixins/slotProxy'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import price from '@/mixins/price'
import { mapActions } from 'vuex'

export default {
  name: 'TariffModalWrapper',
  components: { TariffChangeBookingModal },
  data () {
    return {
      show: false,
      tariff: [],
      currentCustomer: [],
      contractUri: null,
      bookedTariff: [],
      notification: []
    }
  },
  mixins: [
    durationUnit,
    price,
    slotProxy()
  ],
  computed: {
    modalContent: function () {
      return {
        title: this.tariff.name,
        detailBoxes: this.createDetails(),
        slotData: this.createSlotData(this.tariff),
        documentUrl: this.createContractUrl(),
        theme: this.tariff.tariffId,
        messageBox: this.notification
      }
    }
  },
  methods: {
    ...mapActions('bookTariff', [
      'confirmTariff'
    ]),
    booking () {
      const me = this
      this.confirmTariff().then(() => {
        me.$emit('refresh')
        this.show = false
      }, () => {
        this.show = false
      })
    },
    showTariffsModal (tariff, contractUrl, bookedTariff, notification) {
      this.show = true
      this.contractUri = contractUrl
      this.tariff = tariff
      this.bookedTariff = bookedTariff
      this.notification = notification
    },
    createActions () {
      return [
        {
          type: 'booking',
          text: this.tariff?.tariffExtra?.bookingAction || 'Jetzt wechseln',
          disabled: false
        }
      ]
    },
    createDetails () {
      const flatTexts = []
      if (this.tariff.phoneFlat === 'all') {
        flatTexts.push(this.tariff.tariffExtra.flatTexts.phone)
      }
      if (this.tariff.smsFlat === 'all') {
        flatTexts.push(this.tariff.tariffExtra.flatTexts.sms)
      }
      let volumes = []
      if (this.tariff.tariffExtra !== undefined && this.tariff.tariffExtra.volumes instanceof Array) {
        volumes = this.tariff.tariffExtra.volumes
      }
      const priceDetail = {
        primary: this.price(this.tariff.basicFee),
        secondary: this.tariff.runtime?.amount === 0 ? null : '/' + this.tariff.runtime?.amount + ' ' + this.durationUnit(this.tariff.runtime?.unit.toUpperCase(), this.tariff.runtime?.amount)
      }
      return [...flatTexts, ...volumes, priceDetail]
    },
    isBalanceLow () {
      return this.tariff.basicFee > this.currentCustomer.balance
    },
    createSlotData (tariff) {
      return {
        name: tariff.name,
        formattedPrice: tariff.formattedBasicFee,
        duration: this.durationUnit(tariff.runtime?.unit.toUpperCase(), tariff.runtime?.amount),
        amount: tariff.runtime?.amount,
        balance: this.price(this.currentCustomer.balance),
        endOfRuntime: null,
        start: this.bookedTariff.possibleChangingDate
      }
    },
    createContractUrl () {
      if (this.contractUri) {
        return this.contractUri
      }
      return null
    },
    disableButton (option) {
      return this.isBalanceLow(option) && !option.automaticExtension
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(gql`query tariffOptions {
        currentCustomer {
          balance
        }
      }`, this, 'currentCustomer')
    }
  }
}
</script>
